import {combineReducers} from "redux";
import Org from "./organization.reducers";
import Sim from "./sims.reducer";
import Group from "./group.reducer";
import Inventory from "./inventory.reducer";
import InventoryReports from "./inventoryReports.reducer";
import Dashboard from "./dashboard.reducer";
import Users from "./users.reducer";
import Jobs from "./jobs.reducer";
import Notifications from "./notifications.reducer";
import Theme from "./theme.reducers";

const reducers = combineReducers({
  org: Org,
  sim: Sim,
  group: Group,
  inventory: Inventory,
  inventoryReports: InventoryReports,
  dashboard: Dashboard,
  users: Users,
  jobs: Jobs,
  notifications: Notifications,
  theme: Theme,
});

export default reducers;
